function isInternetExplorer(): boolean {
  try {
    const ua = navigator.userAgent
    return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1
  } catch {
    return false
  }
}

const checkBrowserType = {
  isInternetExplorer
}

export default checkBrowserType
